import { BookOpen } from "lucide-react";
import React, { useEffect, useState } from "react";
import {
  assignGuidesToStudents,
  getBatchAssignedCandidateData,
  getBatchDropdownData,
} from "../../../../../../../api/globalAdmin/Index";
import Utils from "../../../../../../../utils/Utils";
import { Modal, notification, Select } from "antd";
import WebUtils from "../../../../../../../utils/WebUtils";

function AssignGuideCandidateModal({
  assignGuideCandidateFlag,
  setAssignCandidateBatchFlag,
  setLoading,
  refreshApis,
}) {
  const jobGuideId = window.location.pathname.split("/").pop();
  const userDetail = Utils.getUserDetail();

  const [batchGuideData, setBatchGuideData] = useState([]);
  const [candidateData, setCandidateData] = useState([]);
  const [assignCandidateData, setAssignCandidateData] = useState([]);
  const [selectedBatchGuides, setSelectedBatchGuides] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState([]);

  const getJobGuideData = () => {
    const url = `${getBatchDropdownData}?organizationId=${userDetail.organizationId}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let data = result?.data?.data;
          setBatchGuideData(data);
          setSelectedBatchGuides(data?.[0]?.batchIdentifier);
          //   setBatchAssignedGuideData(data?.guideAssignedBatches);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getCandidateData = (id) => {
    const url = `${getBatchAssignedCandidateData}?organizationId=${userDetail.organizationId}&jobGuideIdentifier=${jobGuideId}&batchIdentifier=${id}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let data = result?.data?.data;
          setCandidateData(data?.batchCandidateData);
          setAssignCandidateData(data?.AssignedBatchCandidateData);
          const assignedUserIds =
            data?.AssignedBatchCandidateData?.map(
              (item) => item?.userIdentifier,
            ) || [];

          const selectedCandidate = data?.batchCandidateData?.find(
            (item) => !assignedUserIds.includes(item?.userIdentifier),
          );

          setSelectedCandidate(
            selectedCandidate ? [selectedCandidate.userIdentifier] : [],
          );
          //   setBatchAssignedGuideData(data?.guideAssignedBatches);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignToStudents = () => {
    let url = `${assignGuidesToStudents}`;
    // console.log(formData);

    const selectedObj = candidateData
      .filter((item) => selectedCandidate.includes(item.userIdentifier))
      .map(({ userIdentifier, ...rest }) => ({
        userId: userIdentifier,
        ...rest,
      }));
    const batchGuide = batchGuideData.find(
      (item) => item.batchIdentifier === selectedBatchGuides,
    );
    let reqBody = {
      candidateData: selectedObj,
      jodGuideIds: [jobGuideId],
      organizationId: userDetail.organizationId,
      userIdentifier: userDetail.userIdentifier,
      batchName: batchGuide.batchName,
      batchIdentifier: batchGuide.batchIdentifier,
    };

    // {
    //   candidateIds: selectedCandidate,
    //   jodGuideIds: [jobGuideId],
    //   organizationId: userDetail.organizationId,
    //   userIdentifier: userDetail.userIdentifier,
    // };
    setLoading(true);
    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guides assign to students! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setAssignCandidateBatchFlag(false);
          refreshApis();
        } else {
          notification.error({
            message: "Failed",
            description: `${result.data.resultStatusInfo.message}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleSubmit = () => {
    console.log(selectedCandidate);
    assignToStudents();
  };

  useEffect(() => {
    getJobGuideData();
  }, []);

  useEffect(() => {
    if (selectedBatchGuides) {
      getCandidateData(selectedBatchGuides);
    }
  }, [selectedBatchGuides]);

  const guideOptions = Array.from(
    new Map([
      ...(batchGuideData || []).map((item) => [
        item.batchIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.batchName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.batchIdentifier})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                Created on{" "}
                {new Date(item.creationDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </div>
          ),

          value: item.batchIdentifier,
          title: item.batchName,
        },
      ]),
    ]).values(),
  );
  const candidateOptions = Array.from(
    new Map([
      ...(candidateData || []).map((item) => [
        item.userIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.firstName} {item?.lastName}
                <span className="text-[.75rem] text-gray-500">
                  ({item.studentId})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                User ID: {item?.userIdentifier}
              </p>
            </div>
          ),

          value: item.userIdentifier,
          title: item.firstName + " " + item?.lastName,
        },
      ]),

      ...(assignCandidateData || []).map((item) => [
        item.userIdentifier,
        {
          label: (
            <div className="opacity-50">
              <p className="font-medium mb-0 text-gray-900">
                {item.firstName} {item?.lastName}
                <span className="text-[.75rem] text-gray-500">
                  ({item.studentId})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                User ID: {item?.userIdentifier}
              </p>
              <p className="text-[.75rem] text-gray-500 mb-0">
                Already Assigned
              </p>
            </div>
          ),

          value: item.userIdentifier,
          title: item.firstName + " " + item?.lastName,
          disabled: true,
        },
      ]),
    ]).values(),
  );

  return (
    <Modal
      open={assignGuideCandidateFlag}
      onCancel={() => setAssignCandidateBatchFlag(false)}
      footer={null}
      centered
      width={550}
      title={
        <div className="flex items-center gap-2">
          <span className="p-[9px] rounded-lg border-[2px] border-gray-200 shadow-sm">
            {" "}
            <BookOpen size={22} color="#475467" />
          </span>
          <div>
            <p className="text-[1rem] font-semibold ">
              Assign guide to students
            </p>
            <p className="text-[.78rem] font-normal sub-text-color">
              Assign guides to help students prepare for interviews and
              assessments.
            </p>
          </div>
        </div>
      }
    >
      <div className="mt-5">
        <p className="text-[.9rem] font-medium text-[#344054] mb-2">
          Select Batch Guides
        </p>

        <Select
          //   mode="multiple"
          allowClear
          className="w-full"
          size="large"
          placeholder="Select a batch from list"
          value={selectedBatchGuides}
          onChange={setSelectedBatchGuides}
          options={guideOptions}
          //   maxTagCount="responsive"
          optionLabelProp="title"
        />
        <p className="text-[.9rem] font-medium mb-2 mt-4">Select Students</p>
        <Select
          mode="multiple"
          allowClear
          className="w-full"
          size="large"
          placeholder="Select a batch from list"
          value={selectedCandidate}
          onChange={setSelectedCandidate}
          options={candidateOptions}
          maxTagCount="responsive"
          optionLabelProp="title"
        />
      </div>
      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setAssignCandidateBatchFlag(false)}
        >
          Cancel
        </button>

        <button
          disabled={selectedCandidate?.length < 1}
          onClick={handleSubmit}
          className={` ${selectedCandidate?.length < 1 ? "btn-disabled" : "btn-orange"} px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Assign Guide
        </button>
      </div>
    </Modal>
  );
}

export default AssignGuideCandidateModal;
